"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var DetailDataSingleLabel_1 = __importDefault(require("../contract_form/DetailDataSingleLabel"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var SalesForceButtonArea_1 = __importDefault(require("./SalesForceButtonArea"));
var DatePickerWrapper_1 = __importDefault(require("../datepicker/DatePickerWrapper"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var sales_force_auto_complete_1 = __importDefault(require("../../utils/sales_force/sales_force_auto_complete"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var MoveSalesForceButton_1 = __importDefault(require("./MoveSalesForceButton"));
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var PriceBookSelect_1 = __importDefault(require("./PriceBookSelect"));
var ProductSelect_1 = __importDefault(require("./ProductSelect"));
var price_book_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/price_book_utils"));
var OpportunityOldStandardPre = /** @class */ (function (_super) {
    __extends(OpportunityOldStandardPre, _super);
    function OpportunityOldStandardPre() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {};
        _this.showAlertDialog = false;
        _this.alertMessage = '';
        _this.showConfirmDialog = false;
        _this.confirmMessage = '';
        _this.salesForceInfo = {
            torihikisakiId: '',
            oldStandardPrice: '',
            oldStandardContractState: '',
            oldStandardRequestStartDate: null,
            oldStandardContractEdate: null,
            oldStandardItPeriod: '',
            oldStandardBunkatuFlg: '',
            oldStandardItFlg: '',
            oldStandardTokubetuFlg: '',
            oldStandardTokubetuDetail: '',
            opportunityOldStandardId: '',
            opportunityOldStandardName: '',
            oldStandardContractStartDate: null,
            oldStandardPriceBook2Id: '',
            oldStandardProductId: '',
            opportunityOldStandardItemId: '',
            oldStandardPriceBook2Name: '',
            oldStandardPriceBook2Description: '',
            oldStandardProductName: '',
            oldStandardPriceDefault: '',
            oldStandardPriceBookData: [],
            oldStandardProductPlanName: '',
            oldStandardPriceBookUrl: '',
            oldStandardPriceBookMonth: '',
            oldStandardPriceBookBillWay: '',
            applyInfoApplyCapacityOldStandard: '',
            applyInfoOldStandardStartDate: ''
        };
        _this.oldStandardPrice = '';
        _this.oldStandardItFlgDisabled = false;
        _this.oldStandardItFlgDescription = false;
        return _this;
    }
    OpportunityOldStandardPre.prototype.oldStandardPriceChange = function (newPrice) {
        this.oldStandardPrice = String(newPrice);
        this.salesForceInfo.oldStandardPriceDefault = this.oldStandardPrice;
        this.salesForceInfo.oldStandardPrice = this.oldStandardPrice;
    };
    OpportunityOldStandardPre.prototype.priceBookChange = function (newBookInfo) {
        this.salesForceInfo.oldStandardPriceBook2Name = newBookInfo['name'];
        this.salesForceInfo.oldStandardPriceBook2Description = newBookInfo['description'];
        this.salesForceInfo.oldStandardPriceBookUrl = newBookInfo['url'];
        this.salesForceInfo.oldStandardPriceBookBillWay = newBookInfo['BillWay'];
        if (this.isStandardPriceBook(this.salesForceInfo.oldStandardPriceBook2Id)) {
            this.salesForceInfo.oldStandardProductId = '';
        }
    };
    OpportunityOldStandardPre.prototype.productChange = function (newProductInfo) {
        this.salesForceInfo.oldStandardProductName = newProductInfo['name'];
        this.salesForceInfo.oldStandardProductPlanName = newProductInfo['planName'];
        this.salesForceInfo.oldStandardPriceBookMonth = newProductInfo['month'];
        this.salesForceInfo.applyInfoApplyCapacityOldStandard = newProductInfo['capacity'];
        // IT補助金対応商品選択時
        // if (this.salesForceInfo.oldStandardProductPlanName === '2年') {
        //     this.salesForceInfo.oldStandardItFlg = 'true';
        //     this.oldStandardItFlgDisabled = true;
        //     this.oldStandardItFlgDescription = true;
        // } else {
        //     this.salesForceInfo.oldStandardItFlg = null;
        //     this.oldStandardItFlgDisabled = false;
        //     this.oldStandardItFlgDescription = false;
        // }
    };
    OpportunityOldStandardPre.prototype.entryChange = function (newProductItems) {
        this.salesForceInfo.oldStandardPriceBookData = newProductItems;
    };
    OpportunityOldStandardPre.prototype.refs = function () {
        return this.$refs;
    };
    OpportunityOldStandardPre.prototype.getTranslation = function (key) {
        return this.$t(key);
    };
    OpportunityOldStandardPre.prototype.parseDate = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStr(dateStr);
    };
    OpportunityOldStandardPre.prototype.mounted = function () {
        this.initDataChange();
        this.initSalesForceDataChange();
    };
    OpportunityOldStandardPre.prototype.isStandardPriceBook = function (priceBookId) {
        return price_book_utils_1.default.isStandardPriceBook(priceBookId);
    };
    OpportunityOldStandardPre.prototype.isNotStandardPriceBook = function (priceBookId) {
        return !this.isStandardPriceBook(priceBookId);
    };
    OpportunityOldStandardPre.prototype.salesForceAutoComplete = function () {
        if (value_checker_1.default.isBlank(this.salesForceInfo.oldStandardRequestStartDate)) {
            this.salesForceInfo.oldStandardRequestStartDate = sales_force_auto_complete_1.default.getRequestStartDate(this.salesForceInfo.oldStandardContractStartDate);
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.oldStandardContractEdate)) {
            this.salesForceInfo.oldStandardContractEdate = sales_force_auto_complete_1.default.getContractEdate(this.salesForceInfo.oldStandardContractStartDate, this.form.applyInfoOldStandardPeriod);
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.opportunityOldStandardName)) {
            this.salesForceInfo.opportunityOldStandardName = this.form.officeInfoOfficeName + "_" + date_parser_1.default.toString(new Date());
        }
        // IT補助金対応商品選択時
        // if (ValueChecker.isPresent(this.salesForceInfo.oldStandardProductPlanName) && this.salesForceInfo.oldStandardProductPlanName === '2年') {
        //     this.salesForceInfo.oldStandardItFlg = 'true';
        //     this.oldStandardItFlgDisabled = true;
        //     this.oldStandardItFlgDescription = true;
        // }
    };
    OpportunityOldStandardPre.prototype.initDataChange = function () {
        this.form = this.initData;
        this.salesForceAutoComplete();
    };
    OpportunityOldStandardPre.prototype.initSalesForceDataChange = function () {
        this.salesForceInfo = this.initSalesForceData;
        this.salesForceAutoComplete();
    };
    OpportunityOldStandardPre.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, errorMessage;
            return __generator(this, function (_a) {
                self_ = this;
                event.preventDefault();
                if (value_checker_1.default.isBlank(self_.salesForceInfo.torihikisakiId)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_torihikisaki_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.oldStandardPriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_pricebook_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(String(self_.salesForceInfo.oldStandardProductId)) &&
                    this.isNotStandardPriceBook(self_.salesForceInfo.oldStandardPriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_product_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(String(self_.salesForceInfo.oldStandardPrice)) &&
                    this.isNotStandardPriceBook(self_.salesForceInfo.oldStandardPriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_price').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.applyInfoOldStandardStartDate)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.arert_start_date').toString();
                    return [2 /*return*/];
                }
                if (this.isPriceDifferent() && this.isTokubetuBlank()) {
                    errorMessage = "<div class=\"col\">" +
                        this.$t('view.sales_force.reflect.msg.price_error') +
                        ("<br>\u6A19\u6E96\u4FA1\u683C: <strong>" + this.oldStandardPrice + "</strong><br>") +
                        ("\u8CA9\u58F2\u4FA1\u683C: <strong>" + this.salesForceInfo.oldStandardPrice + "</strong><br>");
                    this.showAlertDialog = true;
                    this.alertMessage = errorMessage;
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isPresent(self_.salesForceInfo.oldStandardBunkatuFlg) &&
                    this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = String(this.$t('view.sales_force.reflect.msg.bunkatu_error'));
                    return [2 /*return*/];
                }
                if (price_book_utils_1.default.isAbnormal(self_.salesForceInfo.oldStandardPriceBook2Id, false) &&
                    this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = String(this.$t('view.sales_force.reflect.msg.tokubetu_error'));
                    return [2 /*return*/];
                }
                this.confirmMessage = '<strong>申込予定のRehab Cloud Standard（旧）の商品</strong>を登録します。よろしいですか？<br>';
                this.confirmMessage += 'この商品は2024/01/01〜2024/03/31の間で利用可能です。';
                this.showConfirmDialog = true;
                return [2 /*return*/];
            });
        });
    };
    OpportunityOldStandardPre.prototype.dialogClose = function () {
        this.showConfirmDialog = false;
        this.showAlertDialog = false;
    };
    OpportunityOldStandardPre.prototype.reflect = function () {
        var self_ = this;
        self_.dialogClose();
        this.$emit('reflect', this.getAjaxInfo());
    };
    OpportunityOldStandardPre.prototype.getPriceErrorMsg = function () {
        if (this.isPriceDifferent()) {
            return this.$t('view.sales_force.reflect.msg.price_warning');
        }
        return '';
    };
    OpportunityOldStandardPre.prototype.isPriceDifferent = function () {
        if (value_checker_1.default.isBlank(this.salesForceInfo.oldStandardPrice)) {
            return false;
        }
        return String(this.oldStandardPrice) !== String(this.salesForceInfo.oldStandardPrice);
    };
    OpportunityOldStandardPre.prototype.isTokubetuBlank = function () {
        return value_checker_1.default.isBlank(this.salesForceInfo.oldStandardTokubetuDetail);
    };
    OpportunityOldStandardPre.prototype.getAjaxInfo = function () {
        // カラム追加した項目は、NullCareをしないと、trim()でエラー
        if (!this.salesForceInfo.opportunityOldStandardId) {
            this.salesForceInfo.opportunityOldStandardId = '';
        }
        if (!this.salesForceInfo.opportunityOldStandardItemId) {
            this.salesForceInfo.opportunityOldStandardItemId = '';
        }
        if (!this.salesForceInfo.torihikisakiId) {
            this.salesForceInfo.torihikisakiId = '';
        }
        return {
            salesForceInfo: {
                torihikisakiId: this.salesForceInfo.torihikisakiId.trim(),
                oldStandardPrice: this.salesForceInfo.oldStandardPrice,
                oldStandardContractState: this.salesForceInfo.oldStandardContractState,
                oldStandardRequestStartDate: this.salesForceInfo.oldStandardRequestStartDate,
                oldStandardContractEdate: this.salesForceInfo.oldStandardContractEdate,
                oldStandardItPeriod: this.salesForceInfo.oldStandardItPeriod,
                oldStandardBunkatuFlg: this.salesForceInfo.oldStandardBunkatuFlg,
                oldStandardItFlg: this.salesForceInfo.oldStandardItFlg,
                oldStandardTokubetuFlg: this.salesForceInfo.oldStandardTokubetuFlg,
                oldStandardTokubetuDetail: this.salesForceInfo.oldStandardTokubetuDetail,
                opportunityOldStandardId: this.salesForceInfo.opportunityOldStandardId.trim(),
                opportunityOldStandardName: this.salesForceInfo.opportunityOldStandardName,
                oldStandardContractStartDate: this.salesForceInfo.oldStandardContractStartDate,
                oldStandardPriceBook2Id: this.salesForceInfo.oldStandardPriceBook2Id,
                opportunityOldStandardItemId: this.salesForceInfo.opportunityOldStandardItemId.trim(),
                oldStandardPriceBook2Description: this.salesForceInfo.oldStandardPriceBook2Description,
                oldStandardPriceBook2Name: this.salesForceInfo.oldStandardPriceBook2Name,
                oldStandardProductName: this.salesForceInfo.oldStandardProductName,
                oldStandardPriceDefault: this.salesForceInfo.oldStandardPriceDefault,
                oldStandardPriceBookData: this.salesForceInfo.oldStandardPriceBookData,
                oldStandardProductPlanName: this.salesForceInfo.oldStandardProductPlanName,
                oldStandardPriceBookUrl: this.salesForceInfo.oldStandardPriceBookUrl,
                oldStandardPriceBookMonth: this.salesForceInfo.oldStandardPriceBookMonth,
                oldStandardPriceBookBillWay: this.salesForceInfo.oldStandardPriceBookBillWay,
                applyInfoOldStandardStartDate: this.salesForceInfo.applyInfoOldStandardStartDate
            },
            reflectType: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_OLD_STANDARD_PRE],
            fetchTypes: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_OLD_STANDARD_PRE]
        };
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityOldStandardPre.prototype, "initData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityOldStandardPre.prototype, "initSalesForceData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], OpportunityOldStandardPre.prototype, "fetchSalesForceInfo", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityOldStandardPre.prototype, "priceBookData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], OpportunityOldStandardPre.prototype, "isLinkComplete", void 0);
    __decorate([
        vue_property_decorator_1.Watch('initData')
    ], OpportunityOldStandardPre.prototype, "initDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initSalesForceData')
    ], OpportunityOldStandardPre.prototype, "initSalesForceDataChange", null);
    OpportunityOldStandardPre = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ProductSelect: ProductSelect_1.default,
                PriceBookSelect: PriceBookSelect_1.default,
                SimpleDialog: SimpleDialog_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                DatePickerWrapper: DatePickerWrapper_1.default,
                SalesForceButtonArea: SalesForceButtonArea_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], OpportunityOldStandardPre);
    return OpportunityOldStandardPre;
}(vue_property_decorator_1.Vue));
exports.default = OpportunityOldStandardPre;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/OpportunityOldStandardPre.vue
// module id = MjjO
// module chunks = 1